import request from 'superagent';
import config from 'app/config';
import { getUserToken } from 'services/authentication';

export default (userId, callback) => {
  const uri = `${config.get('IMPERSONATION_API_HOST')}/v1/users/${userId}/impersonate`;
  return request
    .get(uri)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .end((err, res) => {
      if (err) {
        callback(err);
      } else if (res.body) {
        callback(null, res.body);
      } else {
        callback('Invalid response received');
      }
    });
};
